import React from 'react';
import { Form, Input } from 'antd';

function PasswordInput({
  name, label, rules = [],
}) {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
    >
      <Input.Password />
    </Form.Item>
  );
}

export default PasswordInput;
